import React from 'react';
import { CREATE_POLL_BUTTON_TEXT, EMPTY_LIST_TEXT } from '../../../constans/polls-constants';
import TransparentButton from '../../shared/transparent-button/transparent-button';

interface IProps {
    toggleManagePollModal: () => void;
}

const EmptyList: React.FC<IProps> = ({ toggleManagePollModal }) => {
  return (
    <div className='manage-list-container'>
      <div className='manage-list-info-text'>{EMPTY_LIST_TEXT}</div>
      <TransparentButton customClasses='create-poll-transparent' onClick={toggleManagePollModal}>
        {CREATE_POLL_BUTTON_TEXT}
      </TransparentButton>
    </div>
  );
};

export default EmptyList;